import { AverageHomeValue, HousesSold, YearsExperience } from 'api/types/user';

function createOptions<T extends string>(options: T[]) {
    return options
        .filter((val) => isNaN(Number(val)))
        .map((option) => ({
            value: option,
            label: option,
        }));
}

export const HOUSES_SOLD_OPTIONS = createOptions(Object.keys(HousesSold));

export const AVERAGE_HOME_VALUE_OPTIONS = createOptions(
    Object.keys(AverageHomeValue)
);

export const YEARS_EXPERIENCE_OPTIONS = createOptions(
    Object.keys(YearsExperience)
);
